window.helper = {
    dateDefaultFormat: {
        server: {
            date: 'YYYY-MM-DD',
            time: 'HH:mm:ss',
            dateTime: 'HH:mm:ss - YYYY-MM-DD'
        },
        ux: {
            date: 'DD-MM-YYYY',
            time: 'HH:mm:ss',
            dateTime: 'DD-MM-YYYY HH:mm'
        },
        picker: {
            date: 'dd-mm-yyyy',
            dateTime: 'hh:ii'
        }
    },
    setMessage: function (message, message_type) {
        var html = '<div class="alert alert-' + message_type +'"><a class="close" data-dismiss="alert" href="#">×</a><ul>';

        html += '<li>' + message + '</li>';
        html += '</ul></div>';

        $(html).appendTo('#helper-messages-ct');

        try {
            if($('#helper-messages-ct').data('scroll') && $('#helper-messages-ct').data('scroll').length > 0){
                $('#' + $('#helper-messages-ct').data('scroll')).animate({ scrollTop: 0 }, "fast");
            } else {
                $('body').animate({scrollTop:0}, 'fast');
            }
        } catch(ex) {
            //debug.log(ex);
        }
    },

    emptyMessage: function () {
        $('#helper-messages-ct').empty();
    },

    getNextDateByFrequency: function (date, frequency_type_id, frequency_amount) {
        debug.log('getNextDateByFrequency - ', date);
        if (parseInt(frequency_type_id) == 1 /*Hour*/) {

        } else if (parseInt(frequency_type_id)== 2 /*Day*/) {
            date.setDate(date.getDate() + (1 * frequency_amount));
            debug.log('getNextDateByFrequency - date -', date);
            return date;
        } else if (parseInt(frequency_type_id) == 3 /*week*/) {
            date.setDate(date.getDate() + (7 * frequency_amount));
            return date;
        } else if (parseInt(frequency_type_id) == 4 /*month*/) {
            var nextMonth = date.getMonth() + frequency_amount;
            date.setMonth(nextMonth);
            return date;
        }
    },

    beginingOfWeek: function (d) {
        var day = d.getDay(),
            diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    },

    componentFromStr: function(numStr, percent) {
        var num = Math.max(0, parseInt(numStr, 10));
        return percent ?
        Math.floor(255 * Math.min(100, num) / 100) : Math.min(255, num);
    },

    rgbToHex: function(rgb) {
        var rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
        var result, r, g, b, hex = "";
        if ( (result = rgbRegex.exec(rgb)) ) {
            r = helper.componentFromStr(result[1], result[2]);
            g = helper.componentFromStr(result[3], result[4]);
            b = helper.componentFromStr(result[5], result[6]);

            hex = "#" + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
        }
        return hex;
    },

    validaLaterDateToday: function(elem, date){

        var now = new Date();

        if (date > now) {
           return true;
        }
        else{
            return false;
        }

    },
    validateYear: function(elem, date, year_string){

        //var now_year =  new Date().getFullYear();
        var date_picker_year = date.getFullYear();

        if (parseInt(year_string) < globalConstants.MINIMUM_YEAR) {
            return true;
        }

        if (date_picker_year < globalConstants.MINIMUM_YEAR){
            return true;
        }
        else{
            return false;
        }
    }
}